module.exports = __webpack_public_path__ + "static/img/01huanbao.93cbc164.gif";